var exports = {
  "Lw": "overlay__Z8rkSW",
  "yF": "divider__xh3wM3",
  "KA": "AssistantIconViewport__biPc7e",
};

module.exports = exports;
